import React from 'react';
import { faCars } from '@fortawesome/pro-solid-svg-icons/faCars';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function CarsSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faCars} {...props} />;
}
